export function isDefined<T>(x: T | undefined | null): x is T {
  return x !== null && typeof x !== 'undefined';
}

export function isObject<T extends object>(x: T | undefined | null): x is T {
  return isDefined(x) && typeof x === 'object';
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function isFunction(x: unknown): x is Function {
  return typeof x === 'function';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isString(value: any): value is string {
  return typeof value === 'string';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNumber(value: any): value is number {
  return typeof value === 'number';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isBoolean(value: any): value is boolean {
  return typeof value === 'boolean';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNil(value: any) {
  return value == null;
}

export function stringify<T>(x: T): string {
  return typeof x === 'string' ? x : '';
}
